export default "__VITE_ASSET__CvUZkTkW__"